import React from 'react';
import { HeroImage, AuthErrorType, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useGenericErrorPage } from './useGenericErrorPage';
import { useHistory } from 'react-router-dom';
import { dashboardPagePath, loginRedirectPagePath } from '../../navigation/paths';
import { getOidcErrorType } from 'auth';

export const GenericErrorPage: React.FC = () => {
    const { cmsContent: errorPageContents, isLoading, loadingError } = useGenericErrorPage();
    const history = useHistory();
    const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);
    const { logout } = useOidcAuthentication();
    const errorType = getOidcErrorType() || AuthErrorType.UNEXPECTED_ERR;
    const redirectUserBasedOnErrorType = async (error: AuthErrorType) => {
        switch (error) {
            case AuthErrorType.ALREADY_LOGIN_ERR:
                history.push(dashboardPagePath());
                break;
            default:
                logout({ post_logout_redirect_uri: window.location.origin + loginRedirectPagePath() });
                break;
        }
    };

    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={
                errorPageContents && (
                    <div dangerouslySetInnerHTML={{ __html: errorPageContents[errorType].title || '' }} />
                )
            }
            buttonText={errorPageContents && errorPageContents[errorType].buttonText}
            clickHandler={async () => {
                await redirectUserBasedOnErrorType(errorType);
            }}
        />
    );
};
